import { useUsersList } from '../hooks/use-users-list.hook';
import { CreateOrEditUserModal } from '../../details/actions/edit-user/edit-user-action.component';
import { UserDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { UserListActions } from '../actions/user-list.actions';
import { Snackbar } from '../../../../ui/components/pure/snackbar/snackbar.component';
import { BatchImportModal } from '../actions/batch-import/batch-import-action.component';

type UseUserListResult = ReturnType<typeof useUsersList>;
type Actions = UseUserListResult['actions'];

export function UsersListActionsObserver({
  actions,
  projectID
}: {
  actions: Actions;
  user?: UserDto;
  projectID: string;
}) {
  switch (actions.currentAction) {
    case UserListActions.ADD_USER:
      return (
        <CreateOrEditUserModal
          projectID={projectID}
          onSuccess={() => actions.setAction(UserListActions.ADD_USER_SUCCESS)}
          onAbort={() => actions.setAction(null)}
        />
      );
    case UserListActions.ADD_USER_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          The user has been created
        </Snackbar>
      );
    case UserListActions.BATCH_IMPORT:
      return (
        <BatchImportModal
          currentProjectID={projectID}
          onAbort={() => actions.setAction(null)}
          onSuccess={() => actions.setAction(UserListActions.BATCH_IMPORT_SUCCESS)}
        />
      );
    case UserListActions.BATCH_IMPORT_SUCCESS:
      return (
        <Snackbar severity="success" onClose={() => actions.setAction(null)}>
          Residents updated
        </Snackbar>
      );
    default:
      return null;
  }
}
